import { render } from "./product.vue?vue&type=template&id=13fe8686&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=13fe8686&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-13fe8686"

export default script